import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  AddPublicKeyParams,
  AddPublicKeyResponse,
  CreateKeyPairParams,
  CreateKeyPairResponse,
  DeleteKeyPairParams,
  DeleteKeyPairResponse,
  GetKeyPairsParams,
  GetKeyPairsResponse,
  KeyPair,
  PublicKey
} from "./types";

export type SecurityState = {
  keyPair: KeyPair | null;
  publicKey: PublicKey | null;
  keyPairs: KeyPair[] | null;
  areKeyPairsLoading: boolean;
  // isKeyPairLoading: boolean;
  isKeyPairCreating: boolean;
  isPublicKeyAdding: boolean;
  isKeyPairDeleting: boolean;
};

const initialState: SecurityState = {
  keyPair: null,
  publicKey: null,
  keyPairs: null,
  areKeyPairsLoading: false,
  isKeyPairCreating: false,
  isPublicKeyAdding: false,
  isKeyPairDeleting: false
  // isKeyPairLoading: false
};

const securitySlice = createSlice({
  name: "security",
  initialState,
  reducers: {
    // Get Key Pairs
    getKeyPairsRequest: (state, action: PayloadAction<GetKeyPairsParams>) => {
      state.areKeyPairsLoading = true;
    },
    getKeyPairsSuccess: (state, action: PayloadAction<GetKeyPairsResponse>) => {
      state.keyPairs = action.payload;
      state.areKeyPairsLoading = false;
    },
    getKeyPairsFailure: (
      state,
      action: PayloadAction<{ params: GetKeyPairsParams; error: string }>
    ) => {
      state.areKeyPairsLoading = false;
    },

    // Create Key Pair
    createKeyPairRequest: (
      state,
      action: PayloadAction<CreateKeyPairParams>
    ) => {
      state.isKeyPairCreating = true;
    },
    createKeyPairSuccess: (
      state,
      action: PayloadAction<CreateKeyPairResponse>
    ) => {
      state.keyPair = action.payload;
      state.isKeyPairCreating = false;
    },
    createKeyPairFailure: (
      state,
      action: PayloadAction<{ params: CreateKeyPairParams; error: string }>
    ) => {
      state.isKeyPairCreating = false;
    },

    // Add Public Key
    addPublicKeyRequest: (state, action: PayloadAction<AddPublicKeyParams>) => {
      state.isPublicKeyAdding = true;
    },
    addPublicKeySuccess: (
      state,
      action: PayloadAction<AddPublicKeyResponse>
    ) => {
      state.publicKey = action.payload;
      state.isPublicKeyAdding = false;
    },
    addPublicKeyFailure: (
      state,
      action: PayloadAction<{ params: AddPublicKeyParams; error: string }>
    ) => {
      state.isPublicKeyAdding = false;
    },

    // Delete Key Pair
    deleteKeyPairRequest: (
      state,
      action: PayloadAction<DeleteKeyPairParams>
    ) => {
      state.isKeyPairDeleting = true;
    },
    deleteKeyPairSuccess: (
      state,
      action: PayloadAction<DeleteKeyPairResponse>
    ) => {
      state.isKeyPairDeleting = false;
    },
    deleteKeyPairFailure: (
      state,
      action: PayloadAction<{ params: DeleteKeyPairParams; error: string }>
    ) => {
      state.isKeyPairDeleting = false;
    },

    // Clear
    clear: () => initialState,
    clearKeyPair: (state) => {
      state.keyPair = null;
    }
  }
});

export const {
  getKeyPairsRequest,
  getKeyPairsSuccess,
  getKeyPairsFailure,
  createKeyPairRequest,
  createKeyPairSuccess,
  createKeyPairFailure,
  addPublicKeyRequest,
  addPublicKeySuccess,
  addPublicKeyFailure,
  deleteKeyPairRequest,
  deleteKeyPairSuccess,
  deleteKeyPairFailure,
  clear,
  clearKeyPair
} = securitySlice.actions;

export const { actions: securityActions } = securitySlice;

export const reducer = securitySlice.reducer;
